module.exports = __webpack_public_path__ + "static/android-chrome-384x384-1b690ef7615335ffd3d5b4de77610d06.png";